import { Flex, Input, Select } from '@chakra-ui/react';
import { CampoForm } from '../CampoForm';
import {
	TIPOS_DOCUMENTO,
	TipoDocumento,
	formatDocumento,
	maxDocumento,
	placeholderDocumento,
	rotuloDocumento
} from '../../utils/documento';

type CampoDocumentoProps = {
	tipo: TipoDocumento;
	valor: string;
	onTipoChange: (tipo: TipoDocumento) => void;
	onValorChange: (valor: string) => void;
	erro?: string;
};

/**
 * O par tipo + numero do documento do aluno, num componente so porque os
 * drawers de criacao e de edicao mostram exatamente o mesmo campo - e porque a
 * troca de tipo precisa reformatar o numero, que e a parte facil de esquecer ao
 * repetir o campo na mao.
 *
 * O rotulo do numero acompanha o tipo (CPF, Passaporte, Documento): assim o
 * formulario diz o que esta pedindo sem um texto de ajuda extra embaixo.
 */
export const CampoDocumento = ({ tipo, valor, onTipoChange, onValorChange, erro }: CampoDocumentoProps) => {
	const handleTipo = (novo: TipoDocumento) => {
		onTipoChange(novo);
		// Reformata o que ja esta digitado em vez de limpar: um clique errado no
		// select nao pode apagar o numero.
		onValorChange(formatDocumento(novo, valor));
	};

	return (
		<Flex gap="16px" flexDir={{ base: 'column', sm: 'row' }}>
			<CampoForm label="Tipo de documento" htmlFor="tipoDocumento">
				<Select
					id="tipoDocumento"
					onChange={(e) => handleTipo(e.target.value as TipoDocumento)}
					value={tipo}
				>
					{TIPOS_DOCUMENTO.map((item) => (
						<option value={item.valor} key={item.valor} style={{ color: 'black' }}>
							{item.rotulo}
						</option>
					))}
				</Select>
			</CampoForm>

			<CampoForm label={rotuloDocumento(tipo)} htmlFor="documento" erro={erro}>
				<Input
					id="documento"
					placeholder={placeholderDocumento(tipo)}
					inputMode={tipo === 'CPF' ? 'numeric' : 'text'}
					onChange={(e) => onValorChange(formatDocumento(tipo, e.target.value))}
					value={valor}
					maxLength={maxDocumento(tipo)}
				/>
			</CampoForm>
		</Flex>
	);
};
